import { render, staticRenderFns } from "./guestFeatureRequest.vue?vue&type=template&id=ffe25f62&scoped=true&"
import script from "./guestFeatureRequest.vue?vue&type=script&lang=js&"
export * from "./guestFeatureRequest.vue?vue&type=script&lang=js&"
import style0 from "./guestFeatureRequest.vue?vue&type=style&index=0&id=ffe25f62&lang=scss&scoped=true&"
import style1 from "./guestFeatureRequest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe25f62",
  null
  
)

export default component.exports